export default "/images/vendor/@coreui/icons/svg/flag/cif-fj.svg?9d4e324cb889d4c6b8ad2804fdefa3fa";